import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Logo from "../components/Logo";
import IndexStrip from "../components/IndexStrip";

export default function LegalPage({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-app grain" data-testid={testid}>
      <IndexStrip />
      <div className="py-10 px-6">
        <div className="max-w-3xl mx-auto">
        <Link
          to="/dashboard"
          className="mb-8 flex items-center gap-2 text-muted-fg hover:text-primary-fg text-sm font-mono uppercase tracking-widest"
        >
          <ArrowLeft size={14} /> Back
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <Logo size={28} />
          <div className="font-mono text-xs tracking-[0.22em] uppercase text-muted-fg">
            Breakout / Scanner
          </div>
        </div>

        <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-pos mb-2">
          /// {subtitle}
        </div>
        <h1 className="text-4xl font-medium tracking-tight text-primary-fg mb-2">{title}</h1>
        <div className="text-xs font-mono text-muted-fg uppercase tracking-widest mb-10">
          Last updated: 23 April 2026
        </div>

        <article className="prose-legal">{children}</article>

        <div className="mt-12 pt-6 border-t border-subtle flex flex-wrap gap-4 text-[10px] font-mono uppercase tracking-widest text-muted-fg">
          <Link to="/terms" className="hover:text-primary-fg">Terms</Link>
          <Link to="/refund" className="hover:text-primary-fg">Refund Policy</Link>
          <Link to="/privacy" className="hover:text-primary-fg">Privacy</Link>
          <Link to="/about" className="hover:text-primary-fg">About</Link>
          <Link to="/pricing" className="hover:text-primary-fg">Pricing</Link>
          <span className="ml-auto flex flex-wrap gap-x-4">
            <a href="mailto:breakoutscanner1987@gmail.com" className="hover:text-primary-fg">breakoutscanner1987@gmail.com</a>
          </span>
        </div>
      </div>
      </div>
    </div>
  );
}
